import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import {
  compose,
  withState,
  withHandlers,
  pure,
  lifecycle,
  withProps
} from 'recompose';
import {
  StyledBox,
  StyledList,
  ElementList,
  ActionButton,
  StyledIcon
} from './style';
import { Colapse } from '../../../../assets/images/index';

class RefsStore {
  store(name, value) {
    this[name] = value;
  }
}

export const enhance = compose(
  withState('show', 'toggleBox', false),
  withProps({ refs: new RefsStore() }),
  withHandlers({
    onToggleOptions: ({ show, toggleBox }) => () => {
      toggleBox(!show);
    },
    handleClickOutside: props => ev => {
      const targetElement = ReactDOM.findDOMNode(
        props.refs[`myWidget${props.id}`]
      );
      const isInside =
        targetElement.contains(ev.target) || targetElement === ev.target;
      if (!isInside) {
        props.toggleBox(false);
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      window.addEventListener('click', this.props.handleClickOutside);
    },
    componentWillUnmount() {
      window.removeEventListener('click', this.props.handleClickOutside);
    }
  }),
  pure
);
export const ListBoxView = ({
  options,
  show,
  type,
  onToggleOptions,
  onClickOption,
  className,
  refs,
  id
}) => (
  <StyledBox
    className={`${className} ListBox`}
    ref={r => refs.store(`myWidget${id}`, r)}
  >
    <StyledIcon
      color="main"
      size="s"
      svg={Colapse}
      onClick={onToggleOptions}
      hover
    />
    <StyledList type={type} show={show}>
      {options.map(option => (
        <ElementList key={option.name}>
          <ActionButton onClick={() => onClickOption(option.action)}>
            {option.name}
          </ActionButton>
        </ElementList>
      ))}
    </StyledList>
  </StyledBox>
);

ListBoxView.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, action: PropTypes.string })
  ),
  show: PropTypes.bool,
  type: PropTypes.string,
  onToggleOptions: PropTypes.func,
  className: PropTypes.string
};

ListBoxView.defaultProps = {
  type: 'colorOne'
};

export default enhance(ListBoxView);
